module.exports = __webpack_public_path__ + "static/media/stripe-secure.e3db518b.png";